module.exports = function() {
  return new Worker(__webpack_public_path__ + "cc802f41269bef38b644.worker.js");
};


// WEBPACK FOOTER //
// ./src/parse-map.worker.js